export const menuData = [
    {title: "Services", link: "#services"},
    {title: "About", link: "#about"},
    {title: "Contact", link: "#contact"},
]